// @flow
import { CSRF_COOKIE_NAME } from 'services/session/constants'

export default {
  timeout: 10000,
  xsrfCookieName: CSRF_COOKIE_NAME,
  xsrfHeaderName: 'X-CSRF-Token',
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
}
